import AlertView from './AlertViewContainer';
export default AlertView;
